import { useScreenWidth } from "../../helpers/useScreenWidth";
import "./index.css";

export const ContainerBottom = ({ children, height }) => {
  const width = useScreenWidth();
  return (
    <div
      className="container-bottom fixed-bottom"
      style={{
        height: height,
        overflowY: "auto",
        overflowX: "hidden",
        maxWidth: width
      }}
    >
      {children}
    </div>
  );
};
